<p class="mat-body-1" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="5px" style="padding: 30px;">
    <mat-icon class="icon-large translucent">search_off</mat-icon>
    <label class="translucent">Nenhum resultado encontrado</label>
</p>